import { AxiosPromise } from 'axios';
import { IGetHousing } from '../models/employeesHousing.model';
import axios from 'axios';

const uri = '/mgmt/employees/housing';

export const getHousing = (memberCode: string): AxiosPromise<IGetHousing> => {
  return axios.get(`${uri}/${memberCode}`);
}

export const createHousing = (memberCode: string, data: any): AxiosPromise => {
  return axios.post(`${uri}/${memberCode}`, data);
};

export const updateHousing = (memberCode: string, data: any): AxiosPromise => {
  return axios.put(`${uri}/${memberCode}`, data);
};
